import { render } from "./Footer3.vue?vue&type=template&id=555b7d3b&scoped=true"
import script from "./Footer3.vue?vue&type=script&lang=js"
export * from "./Footer3.vue?vue&type=script&lang=js"

import "./Footer3.vue?vue&type=style&index=0&id=555b7d3b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555b7d3b"]])

export default __exports__